<template>
  <div class="MMD">
    <div class="row">
      <div class="col-md-3">
        <Panel class="MMD-flags">
          <template slot="header">
            <span>Flags</span>
            <i class="fas fa-flag ml10" v-tooltip="'This variable is a flag.'"></i>
          </template>

          <Table slot="body">
            <tbody>
              <tr v-for="player in replay.getPlayers ()">
                <td :style="`color: ${rgba ('--wc3-' + player.colour)}`">{{ battleTag (player.name) }}</td>
                <td>{{ ucwords (player.flags.join (', ')) }}</td>
              </tr>
            </tbody>
          </Table>
        </Panel>
      </div>

      <div class="col-md-3" v-for="varname in numberKeys">
        <Panel class="MMD-numbers">
          <template slot="header"><span v-tooltip="capitalize (varname)">{{ capitalize (varname) }}</span>
            <i class="fas fa-infinity ml10" v-tooltip="'This variable is a number.'"></i>
          </template>

          <Table slot="body">
            <tbody>
              <tr
                v-for="playerName in Object.keys (w3mmd.number [varname].values)"
                :style="w3mmd.number [varname].values [playerName] !== null ? `background-color: ${interpolateColour (
                  ( w3mmd.number [varname].values [playerName] - w3mmd.number [varname].extrema.min ) / w3mmd.number [varname].extrema.range * 100,
                  null,
                  null,
                  null,
                  .06
                )}` : ''"
              >
                <td :style="`color: ${rgba ('--wc3-' + replay.getPlayer (playerName).colour)}`">{{ battleTag (playerName) }}</td>
                <td>{{ w3mmd.number [varname].values [playerName] }}</td>
              </tr>
            </tbody>
          </Table>
        </Panel>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" v-for="varname in stringKeys">
        <Panel class="MMD-strings">
          <template slot="header"><span v-tooltip="capitalize (varname)">{{ capitalize (varname) }}</span>
            <i class="fas fa-file-alt ml10" v-tooltip="'This variable is a string.'"></i>
          </template>

          <Table slot="body">
            <tbody>
              <tr v-for="playerName in Object.keys (w3mmd.string [varname].values)">
                <td :style="`color: ${rgba ('--wc3-' + replay.getPlayer (playerName).colour)}`">{{ playerName }}</td>
                <td  style="max-width: 200px">{{ w3mmd.string [varname].values [playerName] }}</td>
              </tr>
            </tbody>
          </Table>
        </Panel>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3" v-for="varname in emptyKeys">
        <Panel class="MMD-empty">
          <template slot="header"><span v-tooltip="capitalize (varname)">{{ capitalize (varname) }}</span>
            <i class="fas fa-question ml10" v-tooltip="'This variable was defined but never updated.'"></i>
          </template>

          <Table slot="body">
            <tbody>
              <tr v-for="playerName in Object.keys (w3mmd.empty [varname].values)">
                <td :style="`color: ${rgba ('--wc3-' + replay.getPlayer (playerName).colour)}`">{{ playerName }}</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </Panel>
      </div>
    </div>

    <a :href='`https://w3mmd.deno.dev/${replay.id}`' target="_blank" class="yellow d-block mt20">View Raw MMD Data</a>



    <!-- <Table>
      <thead>
        <tr>
          <th></th>
          <th v-for="player in replay.data.game.players">
            <div><span>{{ player.name }}</span></div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="variable in intVariables">
          <td class="MMD-key">{{ capitalize (variable) }}</td>
          <td class="MMD-value" v-for="player in replay.data.game.players">
            {{ player.variables [variable] }}

            <Bar :fill="relative (`variables.${variable}`, player, replay.data.game.players)"
                 width="70px"></Bar>
          </td>
          <td></td>
        </tr>
      </tbody>
    </Table> -->

<!--     <Table class="mt30">
      <thead>
        <tr>
          <th></th>
          <th v-for="player in replay.data.game.players">
            {{ player.name }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="variable in stringVariables">
          <td>{{ capitalize (variable) }}</td>
          <td v-for="player in replay.data.game.players">
            {{ player.variables [variable] }}
          </td>
        </tr>
      </tbody>
    </Table> -->
  </div>
</template>

<script>
  import Table from '@/legacy/components/widgets/Table.vue';
  import Panel from '@/legacy/components/widgets/Panel';
  import Bar from '@/legacy/components/widgets/Bar';
  import Replay from '@/legacy/lib//Replay';
  import { ucwords, inArray, relative, interpolateColour } from '@/legacy/lib//util';
  import { capitalize, rgba, metaFactory, battleTag } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.replay.name} Custom Data`,
        description: `Warcraft III meta data (W3MMD) for ${this.replay.name}.`
      });
    },

    props: {
      replay: {
        type: Replay
      }
    },

    data () {
      return {
        w3mmd: this
          .replay
          .getW3mmd ()
      }
    },

    components: {
      Table,
      Panel,
      Bar
    },

    methods: {
      ucwords,
      capitalize,
      relative,
      rgba,
      interpolateColour,
      battleTag
    },

    computed: {
      emptyKeys: function () {
        return Object.keys (this.w3mmd.empty || {});
      },

      numberKeys: function () {
        return Object.keys (this.w3mmd.number || {});
      },

      stringKeys: function () {
        return Object.keys (this.w3mmd.string || {});
      }
    }
  };
</script>

<style lang="scss">
  .MMD {
    .row > div {
      padding: 15px;
    }

    .Panel {
      padding: 0;

      .Panel-header {
        padding: 13px 60px;
        // padding-left: 75px;
        // text-align: left;
        margin: 0;
        position: relative;

        .fas {
          position: absolute;
          left: 6.5px;
          top: 20px;
          font-size: 21px;
        }
      }
    }

    &-numbers {
      // background-color: rgba(var(--green), .02);

      background:
        asset('background/card-5.png')               no-repeat,
        asset('background/card-5-repeat.png') center repeat-y;
    }

    &-strings {
      // background-color: rgba(var(--orange), .02);
    }

    &-empty {
      // background-color: rgba(var(--grey), .02);
    }


    // &-key {
    //   width: 200px;
    //   padding-left: 10px;
    //   text-align: left;
    // }

    // &-value {
    //   width: 150px;
    // }

    // td:last-child:before {
    //   content: '' !important;
    // }
  }
</style>